import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pl-4 pt-2" }

import { ref, watch } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'TdsensorForm',
  props: {
    data: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['inputValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const tdsensor = ref(false);
const beforeTdsensor = ref(false);

const unwatch = watch(
  () => props.data,
  (propsData) => {
    tdsensor.value = propsData.tdsensor;
    beforeTdsensor.value = propsData.tdsensor;
    unwatch();
  }
);

watch(
  () => props.data.tracking_service,
  () => {
    if (!beforeTdsensor.value) beforeTdsensor.value = props.data?.tdsensor;
    let value = beforeTdsensor.value;
    if (props.data?.tracking_service != 'octlink') value = false;

    emit('inputValue', { tdsensor: value });
  }
);

watch(tdsensor, () => {
  beforeTdsensor.value = tdsensor.value;
  emit('inputValue', { tdsensor: tdsensor.value });
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!

  return (props.data?.tracking_service == 'octlink')
    ? (_openBlock(), _createBlock(_component_v_row, {
        key: 0,
        class: "text-form pl-4 pr-3 mb-3 align-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: __props.windowInnerWidth > 800 ? 2 : 3
          }, {
            default: _withCtx(() => [
              _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.validTdsensor')), 1)
            ]),
            _: 1
          }, 8, ["cols"]),
          _createVNode(_component_v_col, {
            cols: __props.windowInnerWidth > 800 ? 10 : 9
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    modelValue: tdsensor.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tdsensor).value = $event)),
                    color: "blue"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})